// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.d4be7fe78',
  revision: 'd4be7fe78',
  branch: 'develop',
  date: 'Fri, 07 Aug 2026 16:17:06 GMT'
};